// Lib 
import { mapState } from "vuex";

// Event, Dialog
import EventBus from "@/event/EventBus";
import commonActionHandle from "@/commonActionHandle";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API, SETTINGS_FIXED_RENTAL_API } from "@/constant/apiSettings";
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { RENT_TYPE, OPERATING_SYSTEM, PACKAGE_TYPE, SERVICE_TYPE, CREATE_IMAGE_STATUS } from "@/constant/rental";
import { PERIOD, PRICE_UNIT, FIXED_RENTAL_STATUS } from "@/constant/fixedRental";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

// Component 
import FixedRentalCampaignName from "@/views/component/FixedRental/FixedRentalCampaignName";
import FixedRentalDescription from "@/views/component/FixedRental/FixedRentalDescription";
import FixedRentalSettings from "@/views/component/FixedRental/FixedRentalSettings";
import PackageInformation from "@/views/component/RentalService/PackageInformation";
import LimitImage from "@/views/component/RentalService/Notification/LimitImage";

// Function 
const queryString = require('query-string');

export default {

    extends: baseRentalService,

    components: {
        FixedRentalCampaignName,
        FixedRentalDescription,
        FixedRentalSettings,
        PackageInformation,
        LimitImage,
    },

    data() {

        return {
            carouselHeight: process.env.VUE_APP_CODE === 'IRENDER_GPU_VN' ? '34.5rem' : '30.5rem',
            targetScrollLeft: 0,
            animationFrame: null,
            rentType: RENT_TYPE,
            priceUnit: PRICE_UNIT,
            operatingSystem: OPERATING_SYSTEM,
            packageTypeList: PACKAGE_TYPE,
            serviceTypeList: SERVICE_TYPE,
            createImageStatus: CREATE_IMAGE_STATUS,
            fixedRentalStatus: FIXED_RENTAL_STATUS,

            isSelectionPackage: true,

            packageType: PACKAGE_TYPE.MULTI2,
            request: {
                rentType: RENT_TYPE.NO_FIXED,

                packageId: null,
                imageName: null,
                operatingSystem: OPERATING_SYSTEM.WINDOWS,
                osVersion: '10',
                osBuild: null,
                masterId: null,

                isShowNumberMachine: true,
                campaignName: null,
                period: PERIOD.SIX_HOUR,
                periodUnit: 1,
                numberMachine: 1,
                totalCost: 0,
                totalCostByHour: 0,
                continueRunning: false,
            },
            servicePackageList: [],
            packageListElement: [],
            packageTypeIndexMap: [],
            maxItemInRows: 2,
            listImageType: {
                cleanImage: 1,
                preInstallSoftware: 2,
            },
            imageType: 2,

            isLoadingMaster: false,
            masterSelected: null,
            listOperatingSystem: [],
            listMaster: []
        };
    },

    props: {
        serviceType: {
            type: Number,
            default: null,
        },
        type: {
            type: Number,
            default: null
        },
    },

    computed: {
        ...mapState({
            serverReport: state => state.common.serverReport,
        }),

        isEnabled1Card() {
            let package1Card = this.servicePackageList.filter(x => x.numberCard === 1).length;
            return package1Card > 0;
        },
        isEnabled2N4Card() {
            let package2_4Card = this.servicePackageList.filter(x => (x.numberCard === 2 || x.numberCard === 4)).length;
            return package2_4Card > 0;
        },
        isEnabled6Card() {
            let package6Card = this.servicePackageList.filter(x => (x.numberCard === 6 || x.numberCard === 8)).length;
            return package6Card > 0;
        },
        isShowGroupTab() {
            let countTab = (this.isEnabled1Card ? 1 : 0) + (this.isEnabled2N4Card ? 1 : 0) + (this.isEnabled6Card ? 1 : 0);
            return countTab > 1;
        },
        packageListElementShow() {
            let dataFilter = this.packageListElement.filter(x => x.data.length > 0);
            this.packageTypeIndexMap = dataFilter.map(x => x.packageType);
            return dataFilter;
        },
        packageListFlat() {
            return this.packageListElementShow.flatMap(x => x.data || []);
        },
        packageListMobile() {
            let dataFilter = this.packageListElement.find(x => x.data.length > 0 && x.packageType === this.packageType);
            return dataFilter.data;
        }
    },

    created() {
        if (this.serviceType && this.type) {
            if (this.serviceType === SERVICE_TYPE.GPUHUB) {
                this.packageType = PACKAGE_TYPE.MULTI2;
            } else {
                this.packageType = PACKAGE_TYPE.SINGLE;
            }
            this.request.rentType = this.type;
            this.servicePackageView();
        }
    },
    beforeDestroy() {
        if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
        }
    },
    methods: {

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.CREATE_IMAGE);
        },
        //#endregion

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion 

        //#region Calculate display price
        calculateDisplayPrice(element, period) {
            element.priceBeforeDecimal = element[this.pricePropertiesName[period]].toFixed(2).toString().split(".")[0];
            element.priceAfterDecimal = element[this.pricePropertiesName[period]].toFixed(2).toString().split(".")[1];

            if (element.priceHourOriginal !== null) {
                element.priceOriginalBeforeDecimal = element.priceHourOriginal.toFixed(2).toString().split(".")[0];
                element.priceOriginalAfterDecimal = element.priceHourOriginal.toFixed(2).toString().split(".")[1];
            }
        },
        //#endregion

        //#region Period change
        periodChange() {
            this.packageListElement.forEach(item => {
                item.data.forEach(element => {
                    this.calculateDisplayPrice(element, this.request.period);
                });
            });
        },
        //#endregion

        //#region Carousel changed
        carouselChanged(value) {
            this.packageType = this.packageTypeIndexMap[value];
            setTimeout(() => {
                this.defaultSelectionPackage(value);
            }, 300);
        },
        //#endregion

        //#region Filter service package
        filterServicePackage(value) {
            let findIndexCarousel = this.packageListElementShow.findIndex(x => x.packageType === parseInt(value));
            this.$refs.carousel.setActiveItem(findIndexCarousel);
            setTimeout(() => {
                this.defaultSelectionPackage(parseInt(value));
            }, 300);
        },
        //#endregion

        //#region Default selection package
        defaultSelectionPackage(packageType) {

            let packageListData = this.packageListElement.find(x => x.packageType === packageType).data;
            let packageIndexSelect = 0;
            if (packageType === PACKAGE_TYPE.SINGLE) {
                packageIndexSelect = 0;
            } else if (packageType === PACKAGE_TYPE.MULTI1) {
                packageIndexSelect = (packageListData.length - 1);
            } else {
                packageIndexSelect = (packageListData.length - 1);
            }

            this.request.packageId = packageListData[packageIndexSelect].id;
            this.packageType = packageType;
            this.operatingSystemListView();
            this.masterListView();
        },
        //#endregion

        handleWheel(e) {
            const el = this.$refs.scrollbar.$el;
            e.preventDefault();
            this.targetScrollLeft = el.scrollLeft + e.deltaY;
            this.smoothScroll(el);
        },

        smoothScroll(el) {
            if (this.animationFrame) {
                return;
            }
            const animate = () => {
                const current = el.scrollLeft;
                const diff = this.targetScrollLeft - current;
                if (Math.abs(diff) < 0.5) {
                    el.scrollLeft = this.targetScrollLeft;
                    this.animationFrame = null;
                    return;
                }
                el.scrollLeft = current + diff * 0.15;
                this.animationFrame = requestAnimationFrame(animate);
            };
            this.animationFrame = requestAnimationFrame(animate);
        },

        scrollItemIntoView(id) {
            const scrollbar = this.$refs.scrollbar.$el;
            const itemRef = this.$refs[`package-${id}`];
            const item = Array.isArray(itemRef) ? itemRef[0] : itemRef;
            if (!item) return;
            const containerRect = scrollbar.getBoundingClientRect();
            const itemRect = item.getBoundingClientRect();
            const padding = 20;
            let target = scrollbar.scrollLeft;
            // Bị khuất bên trái
            if (itemRect.left < containerRect.left + padding) {
                target -= containerRect.left + padding - itemRect.left;
            }
            // Bị khuất bên phải
            if (itemRect.right > containerRect.right - padding) {
                target += itemRect.right - (containerRect.right - padding);
            }
            // Clamp
            target = Math.max(
                0,
                Math.min(target, scrollbar.scrollWidth - scrollbar.clientWidth)
            );
            this.smoothScrollTo(scrollbar, target);
        },
        smoothScrollTo(el, target) {
            target = Math.max(
                0,
                Math.min(target, el.scrollWidth - el.clientWidth)
            );

            this.targetScrollLeft = target;

            if (this.animationFrame) {
                cancelAnimationFrame(this.animationFrame);
            }

            const animate = () => {
                const current = el.scrollLeft;
                const diff = this.targetScrollLeft - current;

                if (Math.abs(diff) < 0.5) {
                    el.scrollLeft = this.targetScrollLeft;
                    this.animationFrame = null;
                    return;
                }

                el.scrollLeft = current + diff * 0.12;

                this.animationFrame = requestAnimationFrame(animate);
            };

            this.animationFrame = requestAnimationFrame(animate);
        },
        //#endregion

        //#region Selection package
        selectionPackage(id) {
            this.packageListElement.forEach(x => {
                x.data.forEach(element => {
                    if (element.id === id) {
                        this.request.packageId = element.id;
                        this.operatingSystemListView();
                        this.masterListView();
                    }
                });
            });
            this.$nextTick(() => {
                this.scrollItemIntoView(id);
            });
        },
        //#endregion   

        selectionOperatingSystem(osItem) {
            this.request.operatingSystem = osItem.osId;
            this.request.osVersion = osItem.osVersion;
            this.request.osBuild = osItem.osBuild;
            this.masterListView();
        },

        //#region Selection Image Type
        selectionImageType(value) {
            this.imageType = value;
            if (value === this.listImageType.preInstallSoftware) {
                this.request.masterId = this.listMaster[0].id;
                this.masterSelected = this.listMaster[0];
            } else {
                this.request.masterId = null;
                this.masterSelected = null;
            }
        },
        //#endregion

        selectionMaster(masterItemIdSelected){
            let masterItemSelected = this.listMaster.find(x => x.id === masterItemIdSelected);
            if(masterItemSelected){
                this.request.masterId = masterItemIdSelected;
                this.masterSelected = masterItemSelected;
            }
        },

        //#region Service package
        servicePackageView() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            let data = {
                serviceType: this.serviceType
            }
            setTimeout(() => {
                api.baseRequest(SETTINGS_RENTAL_API.SERVICE_PACKAGE_VIEW, null, `?${queryString.stringify(data)}`)
                    .then((res) => {
                        let responseData = res.data;
                        if (this.request.rentType === RENT_TYPE.NO_FIXED) {
                            responseData.forEach(element => {
                                this.calculateDisplayPrice(element, PERIOD.HOUR);
                            });
                        } else {
                            responseData = responseData.filter(x => x.id !== '28');
                            responseData.forEach(element => {
                                this.calculateDisplayPrice(element, this.request.period);
                            });
                        }
                        this.servicePackageList = responseData;

                        if (responseData.filter(x => x.numberCard > 1).length > 0) {
                            this.packageListElement = [
                                { data: responseData.filter(x => x.numberCard === 1), packageType: PACKAGE_TYPE.SINGLE },
                                { data: responseData.filter(x => (x.numberCard === 2 || x.numberCard === 4)), packageType: PACKAGE_TYPE.MULTI1 },
                                { data: responseData.filter(x => (x.numberCard === 6 || x.numberCard === 8)), packageType: PACKAGE_TYPE.MULTI2 }
                            ];

                            let lengthItemList = [
                                responseData.filter(x => x.numberCard === 1).length,
                                responseData.filter(x => (x.numberCard === 2 || x.numberCard === 4)).length,
                                responseData.filter(x => (x.numberCard === 6 || x.numberCard === 8)).length
                            ];

                            this.maxItemInRows = Math.max(...lengthItemList);
                            if (lengthItemList[2] > 0) {
                                this.defaultSelectionPackage(PACKAGE_TYPE.MULTI2);
                            }
                            else {
                                if (lengthItemList[1] > 0) {
                                    this.defaultSelectionPackage(PACKAGE_TYPE.MULTI1);
                                }
                                else {
                                    if (lengthItemList[0] > 0) {
                                        this.defaultSelectionPackage(PACKAGE_TYPE.SINGLE);
                                    }
                                }
                            }
                        } else {
                            this.packageListElement = [
                                { data: responseData.filter(x => x.numberCard === 1), packageType: PACKAGE_TYPE.SINGLE },
                            ];
                            let itemsLength = responseData.filter(x => x.numberCard === 1).length;
                            this.maxItemInRows = itemsLength;
                            if (itemsLength > 0) {
                                this.defaultSelectionPackage(PACKAGE_TYPE.SINGLE);
                            }
                        }

                        // process deleted package: remove package deleted from list
                        this.packageListElement.forEach(item => {
                            item.data = item.data.filter(element => !element.deleted);
                        });

                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.servicePackageList);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, this.$t('dialog.requestFailed'))
                    });
            }, this.smoothTimeOut);
        },
        //#endregion 

        isOsEnabled(osId){ 
            switch(osId) {
                case OPERATING_SYSTEM.WINDOWS:
                    return this.servicePackageList && this.servicePackageList.find((x) => x.id === this.request.packageId ).enabledWindows;
                case OPERATING_SYSTEM.UBUNTU:
                    return this.servicePackageList && this.servicePackageList.find((x) => x.id === this.request.packageId ).enabledUbuntu;
            }
            return false;
        },

        //#region OS list view
        operatingSystemListView() {
            let data = {
                packageId: this.request.packageId
            };
            api.baseRequest(SETTINGS_RENTAL_API.OPERATING_SYSTEM_LIST_VIEW, null, `?${queryString.stringify(data)}`)
                .then((res) => {
                    let responsedData = res.data;
                    this.listOperatingSystem = responsedData;
                    if (responsedData.length > 0) {
                        this.selectionOperatingSystem(responsedData[0])
                    } else {
                        this.selectionOperatingSystem({ osId: 1, osVersion: '10', osBuild: null });
                    }
                })
                .catch(error => {
                    this.selectionOperatingSystem({ osId: 1, osVersion: '10', osBuild: null });
                    this.processCatchApiRequest(error, this.$t('createImage.requestOsFailed'))
                });
        },

        //#region Master list view
        masterListView() {
            this.isLoadingMaster = true;
            let data = {
                packageId: this.request.packageId,
                operatingSystem: this.request.operatingSystem,
                osVersion: this.request.osVersion,
                osBuild: this.request.osBuild,
            }
            api.baseRequest(SETTINGS_RENTAL_API.MASTER_LIST_VIEW, null, `?${queryString.stringify(data)}`)
                .then((res) => {
                    let responsedData = res.data;
                    this.listMaster = responsedData.map(xItem => {
                        let jsonDataParsed = [];
                        if(xItem.softwareDetails && xItem.softwareDetails !== null){
                            try{
                                jsonDataParsed = JSON.parse(xItem.softwareDetails);
                            }
                            catch(e){
                                jsonDataParsed = [];
                            }
                        }
                        return {
                            ...xItem,
                            softwareDetails: jsonDataParsed
                        }
                    });
                    // if (responsedData.length > 0) {
                    //     this.selectionImageType(this.listImageType.preInstallSoftware)
                    // } else {
                    //     this.selectionImageType(this.listImageType.cleanImage)
                    // }
                    this.selectionImageType(this.listImageType.cleanImage);
                    this.masterSelected = null;
                    this.isLoadingMaster = false;
                })
                .catch(error => {
                    this.isLoadingMaster = false;
                    this.selectionImageType(this.listImageType.cleanImage);
                    this.processCatchApiRequest(error, this.$t('dialog.requestFailed'));
                });
        },
        //#endregion

        //#region Create image 
        create() {
            let status = null;

            if (this.request.operatingSystem === OPERATING_SYSTEM.WINDOWS) {
                status = this.serverReport.find(x => x.packageId === this.request.packageId).statusWindows;
            } else {
                status = this.serverReport.find(x => x.packageId === this.request.packageId).statusUbuntu;
            }

            if (status === 4) {
                commonActionHandle.showCustomConfirm(
                    this.$t('createImage.confirmCreateTitle'),
                    this.$t('createImage.packageFullMessage'),
                    () => { this.processingCreate(); },
                    () => { },
                    this.$t('createImage.skipAndCreate'),
                    this.$t('api.cancel'),
                    false,
                );
            } else {
                this.processingCreate();
            }
        },
        //#endregion

        processingCreate() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);

            setTimeout(() => {
                let data = {
                    packageId: this.request.packageId,
                    imageName: this.request.imageName,
                    operatingSystem: this.request.operatingSystem,
                    osVersion: this.request.osVersion,
                    osBuild: this.request.osBuild,
                    masterId: this.request.masterId,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                if (this.request.rentType === RENT_TYPE.FIXED_RENTAL) {
                    data.campaignName = this.request.campaignName;
                    data.period = this.request.period;
                    data.periodUnit = this.request.periodUnit;
                    data.numberMachine = this.request.numberMachine;
                    data.continueRunning = this.request.continueRunning;
                }
                api.baseRequest(this.request.rentType === RENT_TYPE.FIXED_RENTAL ? SETTINGS_FIXED_RENTAL_API.FIXED_RENTAL_CREATE_IMAGE : SETTINGS_RENTAL_API.CREATE_IMAGE, data)
                    .then((res) => {
                        switch (res.errorCode) {
                            case CREATE_IMAGE_STATUS.SUCCESS:
                            case FIXED_RENTAL_STATUS.SUCCESS:
                                EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                                this.closeThisPopup();
                                this.notificationSuccess(this.$t('createImage.creatingTitle'), this.$t('createImage.creatingMessage', { name: this.request.imageName ? this.request.imageName : this.$t('createImage.defaultMachineName') }));
                                break;
                            case CREATE_IMAGE_STATUS.LIMITED_IMAGE:
                            case FIXED_RENTAL_STATUS.BALANCE_NOT_ENOUGH:
                            case FIXED_RENTAL_STATUS.MACHINE_NOT_AVAILABLE:
                                setTimeout(() => {
                                    this.isShowErrorInformation = true;
                                }, 500);
                                this.errorCode = res.errorCode
                                break;
                        }
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                        this.$store.dispatch("auth/basicUserInformationView");
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, this.$t('createImage.createImageFailed'))
                    });
            }, this.smoothTimeOut);
        }
    },
}